import { Td, Tr } from "@chakra-ui/table"
import { nanoid } from "@reduxjs/toolkit"
import dayjs from "dayjs"

export const TransferTableBody = ({ getData }) => {
  return (
    <>
      {getData &&
        getData.map(data => {
          return (
            <Tr key={nanoid()}>
              <Td>{data?.transactionChannel}</Td>

              <Td>{data?.userId?.email}</Td>

              <Td>₦ {parseInt(data?.amount).toLocaleString()}</Td>
              <Td>{data?.userId?.tenantName}</Td>
              <Td>{data?.transactioninfo?.tenantPhone}</Td>
              <Td>{dayjs(data?.createdAt).format("HH:mm:a")}</Td>
              <Td>{dayjs(data?.createdAt).format("DD-MMM-YYYY")}</Td>
            </Tr>
          )
        })}
    </>
  )
}
